import React from "react";
import { Progress } from "antd";
import { getFirmwareUpdateProgress } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";

const updateMap = new Map([
  ["", ""],
  ["loading", "命令下发中"],
  ["error", "升级失败"],
  ["success", "升级成功"],
]);

class UpdateProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: 0,
      updateStatus: this.props.updateStatus || "",
    };
    this.interval = null;
  }

  componentDidMount() {
    if (!this.props.updateStatus) {
      this.getProgress();

      this.interval = setInterval(() => {
        this.getProgress();
      }, 2000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  // 获取进度
  getProgress = () => {
    fetchHandler(getFirmwareUpdateProgress, {
      stubId: this.props.record.key,
    }).then((res) => {
      if (res && res.code === "success") {
        let status = "";
        if (res.data.otaCode) {
          status = "error";
        } else {
          if (res.data.otaRate === 0) {
            status = "loading";
          }
          if (res.data.otaRate > 0) {
            status = "updating";
          }

          if (res.data.otaRate === 100) {
            clearInterval(this.interval);

            setTimeout(() => {
              status = "success";
              this.setState({
                updateStatus: status,
              });
            }, 1000);
          }
        }

        this.setState({
          data: res.data.otaRate || 0,
          updateStatus: status,
        });
      }
    });
  };

  render() {
    const { updateStatus } = this.state;
    return (
      <div>
        {updateMap.get(updateStatus) ? (
          <h4 style={{ textAlign: "center" }}>{updateMap.get(updateStatus)}</h4>
        ) : (
          <Progress percent={this.state.data} format={(percent) => `${percent}%`} />
        )}
      </div>
    );
  }
}

export default UpdateProgress;



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/updateProgress.js